webpackJsonp([7],{

/***/ 1251:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(14);

__webpack_require__(1251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icons = exports.Icons = function (_Component) {
  _inherits(Icons, _Component);

  function Icons() {
    _classCallCheck(this, Icons);

    return _possibleConstructorReturn(this, (Icons.__proto__ || Object.getPrototypeOf(Icons)).apply(this, arguments));
  }

  _createClass(Icons, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'componentDoc' },
        _react2.default.createElement(
          'h1',
          { className: 'primaryHeader componentDoc_primaryHeader' },
          'Icons'
        ),
        _react2.default.createElement(
          'p',
          { className: 'paragraph' },
          'Material Design includes a collection of icons. Materialish exports these icons as individual React components for you to use in your applications.'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'icons_links' },
          _react2.default.createElement(
            'li',
            { className: 'icons_link' },
            _react2.default.createElement(
              _reactStatic.Link,
              { to: '/icons/usage' },
              'Usage'
            ),
            ': Learn how to import and use icons in your application'
          ),
          _react2.default.createElement(
            'li',
            { className: 'icons_link' },
            _react2.default.createElement(
              _reactStatic.Link,
              { to: '/icons/catalog' },
              'Catalog'
            ),
            ': View and search the icon collection'
          )
        ),
        _react2.default.createElement(
          'h2',
          { className: 'secondaryHeader componentDoc_standaloneSecondaryHeader' },
          'Useful Links'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'componentDoc_links' },
          _react2.default.createElement(
            'li',
            { className: 'componentDoc_linkItem' },
            _react2.default.createElement(
              'a',
              {
                href: 'https://material.io/tools/icons/?style=baseline',
                className: 'componentDoc_linkAnchor' },
              _react2.default.createElement('i', { className: 'componentDoc_icon zmdi zmdi-file-text' }),
              'Material Design Icons Docs'
            )
          ),
          _react2.default.createElement(
            'li',
            { className: 'componentDoc_linkItem' },
            _react2.default.createElement(
              'a',
              {
                href: 'https://github.com/google/material-design-icons',
                className: 'componentDoc_linkAnchor' },
              _react2.default.createElement('i', { className: 'componentDoc_icon zmdi zmdi-file-text' }),
              'Material Design Icons GitHub Repository'
            )
          )
        )
      );
    }
  }]);

  return Icons;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(Icons);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/icons.59c1c281.js